import * as React from 'react'
import Box from '@mui/material/Box'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import {pink} from '@mui/material/colors'
import {CheckCircle} from '@mui/icons-material'
import CancelIcon from '@mui/icons-material/Cancel'
import {Tooltip} from '@mui/material'
import {Card, KnownDataPoint} from '../model/models'
import HelpIcon from '@mui/icons-material/Help'

interface ConsecutiveCorrectProps {
  card: Card
}

export default function ConsecutiveCorrect(props: ConsecutiveCorrectProps) {
  let knownData: KnownDataPoint[] = props.card.knownData || []
  const emptyCount = knownData.length >= 5 ? 0 : 5 - knownData.length

  if (knownData.length > 0) {
    for (const i in knownData) {
      knownData[i].timestamp = new Date(knownData[i].timestamp)
    }
    knownData = knownData.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime()).slice(0, 5)
  }

  return (
    <>
      <Tooltip disableFocusListener title="consecutive correct" placement="left-start" enterTouchDelay={0}>
        <Box sx={{
          p: .5,
          display: 'flex',
          color: 'text.disabled',
          alignItems: 'center',
          justifyContent: "center",
          alignText: 'center'
        }}>
          <HelpIcon sx={{fontSize: '18px', mr: 0.4, color: 'white'}}/>
          {[...Array(emptyCount)].map((e, i) =>
            <CheckBoxOutlineBlankIcon key={i} sx={{color: 'text.disabled'}}/>
          )}
          {knownData.map((dataPoint, i) => {
            return dataPoint.known ?
              <CheckCircle key={i + emptyCount} color='success'/> :
              <CancelIcon key={i + emptyCount} sx={{color: pink[600]}}/>
          })}
        </Box>
      </Tooltip>
    </>
  )
}
